import { render } from "./VUploadList.vue?vue&type=template&id=8787f26c"
import script from "./VUploadList.vue?vue&type=script&lang=js"
export * from "./VUploadList.vue?vue&type=script&lang=js"

import exportComponent from "/apps/releases/202604221556/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/platform/components/VUploadList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8787f26c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8787f26c', __exports__)) {
    api.reload('8787f26c', __exports__)
  }
  
  module.hot.accept("./VUploadList.vue?vue&type=template&id=8787f26c", () => {
    api.rerender('8787f26c', render)
  })

}


export default __exports__